import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {API_URLS} from 'src/environments/env-routes';
import {APIHelper} from 'src/shared/services/api-helper/api-helper.service';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  constructor(private api: APIHelper) {}
  public unreadalers: any[];

  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();

  createAlert(data: any): Promise<any> {
    return this.api.requestApi({
      action: API_URLS.alerts.create,
      method: 'POST',
      datas: data
    });
  }

  public getreadAlerts() {
    const args = 'typeOfAlert=CLOSED';
    return this.api.requestApi({
      action: API_URLS.alerts.getalerts,
      queryArgs: args
    });
  }
  public getUnreadAlerts() {
    const args = 'typeOfAlert=CREATED';
    return this.api.requestApi({
      action: API_URLS.alerts.getalerts,
      queryArgs: args
    });
  }

  public changeAlertStatus(comment: string, id: number) {
    return this.api.requestApi({
      action: API_URLS.alerts.changeAlertStatus.replace(
        ':alertId',
        id.toString()
      ),
      method: 'POST',
      datas: comment
    });
  }

  public deleteAlert(id: number) {
    return this.api.requestApi({
      action: API_URLS.alerts.deleteAlert.replace(':alertId', id.toString()),
      method: 'DELETE'
    });
  }
  changeMessage(message: string) {
    this.messageSource.next(message);
  }
}
